// extracted by mini-css-extract-plugin
export var background = "index-module--background--2_gJ1";
export var letters = "index-module--letters--1j2MK";